<template>
  <div class="dark:bg-white border border-white dark:border-black rounded-md">
    <img
      :src="logoUrl"
      alt="Logo"
      class="object-contain"
    >
  </div>
</template>

<script setup>
import { usePage } from '@inertiajs/vue3';
import { computed } from 'vue';
import defaultLogo from '../../images/logo.png';

defineOptions({
  inheritAttrs: false,
});

defineProps({
  className: {
    type: String,
    default: '',
  },
  negative: {
    type: Boolean,
    default: false,
  },
});

const page = usePage();

const logoUrl = computed(() => page.props.tenantLogoUrl || defaultLogo);
</script>
